export enum Ethnicity {
    white = 'non-hispanic: white population',
    hispanic = 'hispanic: latino american',
    africanAmerican = 'african american',
    asianPacificIslander = 'asian and pacific islandern',
    // africanAmerican = 'african american'
}